import paymentsApi from '@/api/payments'
import { saveIVKey } from '@/utils/IVKeys'

const getDefaultState = () => ({
  data: {}
})

const state = getDefaultState()

const mutations = {
  SET_DATA: (state, data) => {
    state.data = data
  }
}

const actions = {
  async createTagSaleOrder ({ commit, state, rootState, rootGetters }) {
    const params = {
      kind: 'tag',
      identifier: rootState.rechargeTagForm.tag,
      email: rootState.rechargeTagForm.cardHolderEmail,
      amount: rootState.rechargeTagForm.amount,
      card: rootState.rechargeTagForm.cardNumber,
      card_type: rootState.rechargeTagForm.cardType,
      expiration: rootGetters['rechargeTagForm/cardExpirationDate']
    }

    try {
      const { data } = await paymentsApi.v2.preparePayment(params)

      commit('SET_DATA', data)

      saveIVKey({
        orderId: data.id,
        ivKey: data.iv_key,
        ivKeyExp: data.iv_key_expires_at
      })
    } catch (error) {
      // TODO: Show error modal
      // console.log(error)
    }
  },
  async createCardSaleOrder ({ commit, state, rootState, rootGetters }) {
    const params = {
      kind: 'card',
      identifier: rootState.rechargeCardForm.card,
      email: rootState.rechargeCardForm.cardHolderEmail,
      amount: rootState.rechargeCardForm.amount,
      card: rootState.rechargeCardForm.cardNumber,
      card_type: rootState.rechargeCardForm.cardType,
      expiration: rootGetters['rechargeCardForm/cardExpirationDate']
    }

    try {
      const { data } = await paymentsApi.v2.preparePayment(params)

      commit('SET_DATA', data)

      saveIVKey({
        orderId: data.id,
        ivKey: data.iv_key,
        ivKeyExp: data.iv_key_expires_at
      })
    } catch (error) {
      // TODO: Show error modal
      // console.log(error)
    }
  }
}

const getters = {
  saleOrderReference3D: (state) => {
    if (state.data.id) {
      return `${state.data.id}-auth${process.env.VUE_APP_AUTH_CODE_PREFIX}`
    }

    return ''
  },
  saleOrderId: (state) => {
    return state.data.id
  },
  saleOrderTotal: (state) => {
    return state.data.total
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
